var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvSensorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1698 6.96981C32.8383 3.63822 28.4069 1.80746 23.6974 1.80746C18.9814 1.80746 14.5566 3.63822 11.225 6.96981C7.89338 10.3014 6.05615 14.7327 6.05615 19.4422C6.05615 28.9712 15.0676 36.9024 19.913 41.159C20.5858 41.7542 21.1615 42.2653 21.6273 42.6922C22.2095 43.2356 22.9535 43.5073 23.6974 43.5073C24.4414 43.5073 25.1853 43.2356 25.761 42.6922C26.2268 42.2653 26.809 41.7542 27.4818 41.159C32.3207 36.9024 41.3322 28.9712 41.3322 19.4422C41.3322 14.7327 39.5014 10.3014 36.1698 6.96981Z",
    fill: "#0A6543",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.571 14.7365C32.0742 14.7365 34.9113 14.4158 34.9113 14.0212L33.3817 12.6149C33.3077 12.7629 33.0118 12.8863 31.9014 13.0096C31.0133 13.1083 29.8292 13.1576 28.5709 13.1576C27.3127 13.1576 26.1285 13.1083 25.2403 13.0096C24.1302 12.8863 23.834 12.7383 23.76 12.6149L22.2305 14.0212C22.2305 14.4159 25.0676 14.7365 28.5707 14.7365H28.571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.258 12.5168C33.258 12.8029 31.1594 13.0347 28.5707 13.0347C25.9818 13.0347 23.8833 12.8029 23.8833 12.5168C23.8833 12.2306 25.9819 11.9986 28.5707 11.9986C31.1594 11.9986 33.258 12.2306 33.258 12.5168Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0854 14.6629C31.8765 14.8109 30.2728 14.8849 28.5707 14.8849C26.8685 14.8849 25.265 14.8109 24.0808 14.6875C23.9574 14.6629 23.834 14.6629 23.7108 14.6381L22.2305 15.995C22.2305 16.3898 25.0675 16.7104 28.5707 16.7104C32.0739 16.7104 34.911 16.3896 34.911 15.995L33.4307 14.6381C33.3319 14.6383 33.2085 14.6629 33.0853 14.6629H33.0854Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5212 21.4476C28.0525 21.4476 27.6331 21.4229 27.2877 21.3982C27.0657 21.3736 26.9177 21.3488 26.8438 21.3242V28.5279C26.9424 28.6019 27.5591 28.6759 28.5212 28.6759C29.4834 28.6759 30.0755 28.5773 30.1987 28.5279V21.2995C30.1001 21.3241 29.9767 21.3489 29.7548 21.3735C29.4094 21.4229 28.9652 21.4475 28.5212 21.4475V21.4476Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5216 18.8569C27.6088 18.8569 26.7453 18.8075 26.0792 18.7336C25.6352 18.6843 25.3884 18.6349 25.2158 18.5856L26.8193 21.1512C26.8933 21.2252 27.5101 21.2992 28.4968 21.2992C29.4835 21.2992 30.1003 21.2006 30.1743 21.1512L31.8027 18.5856C31.6547 18.6349 31.3834 18.6842 30.9392 18.7336C30.2978 18.8077 29.4343 18.8569 28.5215 18.8569H28.5216Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5215 28.7985C28.0527 28.7985 27.6333 28.7739 27.288 28.7491C27.1152 28.7245 26.992 28.6997 26.918 28.6997L27.6581 30.0072V32.2769C27.6581 32.7209 27.9789 33.1156 28.3983 33.165C28.9164 33.239 29.3604 32.8196 29.3604 32.3263V30.0072L30.1006 28.7243C30.002 28.7489 29.9032 28.7737 29.7306 28.7737C29.4096 28.7739 28.9655 28.7985 28.5215 28.7985L28.5215 28.7985Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1416 16.7112V18.3887C25.2896 18.5121 26.5479 18.7095 28.5214 18.7095C30.4951 18.7095 31.7531 18.5367 31.9012 18.3887V16.7112C30.8896 16.7852 29.7301 16.8346 28.5214 16.8346C27.2879 16.8346 26.1284 16.7852 25.1416 16.7112Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.946 20.5105C22.872 20.5351 22.8226 20.5351 22.7486 20.5599C22.872 21.0038 22.946 21.5466 22.946 22.1633L19.2208 22.8541C19.1468 22.4841 18.8261 22.188 18.4313 22.188C18.3327 22.188 18.2339 22.2126 18.1599 22.2374L16.6796 19.6963C16.877 19.4003 17.025 19.0549 17.0496 18.6848C17.1236 17.7967 16.6056 16.9579 15.7914 16.6372C15.3475 16.4644 14.8787 16.4398 14.4593 16.5632C14.5827 17.0813 14.6567 17.7227 14.6567 18.4381C14.6567 19.2276 14.5581 19.9429 14.41 20.4857C15.0761 20.6831 15.7421 20.5351 16.2602 20.1649L17.7157 22.6566C17.6663 22.78 17.6171 22.9034 17.6171 23.0266V23.2979L14.9773 24.8522C15.0019 24.4575 15.0759 24.0875 15.1501 23.7667C15.0761 23.7421 15.0267 23.7173 14.9527 23.7173C13.8426 23.4705 12.7325 24.2107 12.5103 25.3456C12.3129 26.4063 13.0285 27.4918 14.0892 27.714C14.4592 27.788 14.8294 27.7634 15.1499 27.64C15.0019 27.0973 14.9032 26.3571 14.9032 25.5429L17.5676 23.9641V32.3026C17.5676 32.722 17.8883 33.1167 18.3077 33.1414C18.8011 33.1907 19.1958 32.796 19.1958 32.3272L19.196 23.4464L22.8965 22.7556C22.8719 23.397 22.7979 23.9891 22.6498 24.4331C22.9951 24.5565 23.3405 24.5811 23.7105 24.5071C24.7712 24.2851 25.4868 23.2242 25.2894 22.1387C25.1662 21.0041 24.0806 20.2639 22.9459 20.5106L22.946 20.5105Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5143",
    x: 0.556152,
    y: 0.307465,
    width: 46.2759,
    height: 52.6999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5143",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvSensorIcon);
export default __webpack_public_path__ + "static/media/envSensorIcon.0cc67c1f645466d276681c132f0e6144.svg";
export { ForwardRef as ReactComponent };